import useSeo from "@/lib/useSeo";
import PageHero from "@/components/site/PageHero";
import About from "@/components/sections/About";
import Stats from "@/components/sections/Stats";
import CtaBanner from "@/components/site/CtaBanner";

export default function UeberUns() {
    useSeo({
        title: "Über uns – Alpen Reinigung Innsbruck (Inh. Faisal Safi)",
        description:
            "Alpen Reinigung ist ein persönlich geführtes Reinigungsunternehmen in Innsbruck (Tirol). Inhaber Faisal Safi steht für Sauberkeit, Qualität und Zuverlässigkeit.",
        path: "/ueber-uns",
    });
    return (
        <div>
            <PageHero
                eyebrow="Über uns"
                title="Persönlich geführt. In Innsbruck zuhause."
                lead="Alpen Reinigung steht für eine moderne, persönlich geführte Reinigung in Innsbruck und ganz Tirol. Unser Anspruch: Qualität, die man sieht – und Zuverlässigkeit, auf die man baut."
                breadcrumbs={[{ label: "Über uns" }]}
            />
            <About />
            <Stats />
            <CtaBanner title="Lernen Sie uns kennen" subtitle="Ein kurzes Telefonat reicht oft schon, um ein passendes Angebot zu erstellen." />
        </div>
    );
}
